import files from './files';

const THROTTLE_MS = 800;
const MIN_PROGRESS_DELTA_PERCENT = 1;
const timers = new Map();
const lastSent = new Map();
const lastSentProgress = new Map();

function buildPayload(upload, status) {
    const totalBytes = upload.size || 0;
    const completed = status === 'completed';
    const uploadedBytes = completed ? totalBytes : Math.min(upload.uploadedSize || 0, totalBytes);
    const progressPercent = completed
        ? 100
        : totalBytes > 0
            ? Math.round((uploadedBytes / totalBytes) * 1000) / 10
            : Math.round((upload.progress || 0) * 10) / 10;
    return { progressPercent, uploadedBytes, totalBytes, status };
}

function send(store, uploadId, force = false) {
    const upload = store.state.upload.uploads.find((u) => u.id === uploadId);
    if (!upload || !upload.serverFileId) return;
    const status = upload.status === 'completed' ? 'completed' : upload.status === 'failed' ? 'failed' : 'in_progress';
    const payload = buildPayload(upload, status);

    if (!force && status === 'in_progress') {
        const previousProgress = lastSentProgress.get(uploadId);
        if (previousProgress !== undefined && (payload.progressPercent - previousProgress) < MIN_PROGRESS_DELTA_PERCENT) {
            return;
        }
    }

    lastSent.set(uploadId, Date.now());
    lastSentProgress.set(uploadId, payload.progressPercent);
    files.reportUploadProgress(upload.serverFileId, payload).catch((error) => {
        console.warn('Falha ao enviar progresso do upload:', error?.message || error);
    });
}

function flush(store, uploadId) {
    const timer = timers.get(uploadId);
    if (timer) {
        clearTimeout(timer);
        timers.delete(uploadId);
    }
    send(store, uploadId, true);
}

function schedule(store, uploadId) {
    if (timers.has(uploadId)) return;
    const wait = Math.max(0, THROTTLE_MS - (Date.now() - (lastSent.get(uploadId) || 0)));
    timers.set(uploadId, setTimeout(() => {
        timers.delete(uploadId);
        send(store, uploadId);
    }, wait));
}

export function setupUploadProgressReporter(store) {
    store.subscribeAction({
        after: (action) => {
            const payload = action.payload;
            const uploadId = payload && typeof payload === 'object' ? payload.id : payload;
            if (uploadId === undefined || uploadId === null) return;

            if (action.type === 'upload/updateProgress') {
                schedule(store, uploadId);
            } else if (action.type === 'upload/completeUpload') {
                flush(store, uploadId);
                lastSent.delete(uploadId);
                lastSentProgress.delete(uploadId);
            } else if (action.type === 'upload/failUpload') {
                flush(store, uploadId);
                lastSent.delete(uploadId);
                lastSentProgress.delete(uploadId);
            }
        },
    });
}
